import React, { createContext, useContext, useState } from "react";

const EmsSidePanelContext = createContext({
  open: true,
  setOpen: () => {},
});

/**
 * Owns the AppSidebar's open/collapsed state. The sidebar is now the app's
 * primary navigation surface (see routing/GlobalOutlet.jsx's Layout), so it
 * starts open everywhere rather than only on EMS-gated pages - `setOpen` is
 * just a manual collapse toggle from here on.
 */
export function EmsSidePanelProvider({ children }) {
  const [open, setOpen] = useState(true);

  return (
    <EmsSidePanelContext.Provider value={{ open, setOpen }}>
      {children}
    </EmsSidePanelContext.Provider>
  );
}

export const useEmsSidePanelContext = () => useContext(EmsSidePanelContext);
